import * as React from 'react'
import { Body, ColumnFlexBox, RowFlexBox } from '../../components/templates/Wrappers';
import { CalculationResultsStep, InvestorTestCalculationResult, InvestorTestElement } from '../../components/molecules/InvestorTestElements';
import { IsTablet, useWindowSize } from '../../globals/UIHooks';
import { TabletMax } from '../../globals/UIValues';
import { RiskProfile, RiskProfileCalculation, RiskProfileExpenses, calculateInvestorRiskProfile } from '../../shared/InvestmentKnowledge';
import { lang } from '../../globals/Translations';
import { TranslatedTerms } from '../../globals/TranslatedTerms';

const propertyCheck = (val?: number) => {
  if (val === undefined) return true
  else return isNaN(val)
}
export const PublicInvestorTestItem: React.FC = () => {
  const [salary, setSalary] = React.useState<number | undefined>()
  const [interestIncome, setInterestIncome] = React.useState<number | undefined>()
  const [dividendIncome, setDividendIncome] = React.useState<number | undefined>()
  const [realEstateIncome, setRealEstateIncome] = React.useState<number | undefined>()
  const [pensionAssets, setPensionAssets] = React.useState<number | undefined>()
  const [stockAssets, setStockAssets] = React.useState<number | undefined>()
  const [bondAssets, setBondAssets] = React.useState<number | undefined>()
  const [childSupport, setChildSupport] = React.useState<number | undefined>()
  const [mortgage, setMortgage] = React.useState<number | undefined>()
  const [otherLoans, setOtherLoans] = React.useState<number | undefined>()
  const [insurances, setInsurances] = React.useState<number | undefined>()
  const [utilities, setUtilities] = React.useState<number | undefined>()
  const [subscriptionServices, setSubscriptionServices] = React.useState<number | undefined>()
  const [incometaxAndPropertyTax, setIncometaxAndPropertyTax] = React.useState<number | undefined>()
  const [riskProfileCalculations, setRiskProfileCalculations] = React.useState<RiskProfileCalculation | undefined>()
  const [completed, setCompleted] = React.useState(false)

  const incomeMissing = propertyCheck(salary) || propertyCheck(interestIncome) || propertyCheck(dividendIncome) || propertyCheck(realEstateIncome)
  const assetsMissing = propertyCheck(pensionAssets) || propertyCheck(stockAssets) || propertyCheck(bondAssets)
  const expensesMissing = propertyCheck(childSupport) || propertyCheck(mortgage) || propertyCheck(otherLoans) || propertyCheck(insurances) || propertyCheck(utilities) || propertyCheck(subscriptionServices) || propertyCheck(incometaxAndPropertyTax)

  const handleNext = () => {
    const incomeLocalMissing = salary === undefined || interestIncome === undefined || dividendIncome === undefined || realEstateIncome === undefined
    const assetsLocalMissing = pensionAssets === undefined || stockAssets === undefined || bondAssets === undefined
    const expensesLocalMissing = childSupport === undefined || mortgage === undefined || otherLoans === undefined || insurances === undefined || utilities === undefined || subscriptionServices === undefined || incometaxAndPropertyTax === undefined

    if (incomeLocalMissing || assetsLocalMissing || expensesLocalMissing) {
      return;
    }
    const riskProfile: RiskProfile = {
      riskProfileIncome: { salary, interestIncome, dividendIncome, realEstateIncome },
      riskProfileAssets: { pensionAssets, stockAssets, bondAssets }
    }
    const riskProfileExpenses: RiskProfileExpenses = { childSupport, mortgage, otherLoans, insurances, utilities, subscriptionServices, incometaxAndPropertyTax }

    const newRiskProfileCalculation = calculateInvestorRiskProfile(riskProfile, riskProfileExpenses)
    setRiskProfileCalculations(newRiskProfileCalculation)
    setCompleted(true)
  }
  if (completed) {
    return (
      <ColumnFlexBox>
        {riskProfileCalculations && <InvestorTestCalculationResult calculations={riskProfileCalculations} ignoreExperienceAndEducation={true} step={CalculationResultsStep.ASSETS} />}
        <RowFlexBox>
          <button style={{ marginTop: 12, marginBottom: 12, width: '50%' }} onClick={() => setCompleted(false)} >
            {lang(TranslatedTerms.BACK).toUpperCase()}
          </button>
        </RowFlexBox>
      </ColumnFlexBox>
    )
  }

  return (
    <ColumnFlexBox>
      <InvestorTestElement
        salary={salary}
        setSalary={setSalary}
        interestIncome={interestIncome}
        setInterestIncome={setInterestIncome}
        dividendIncome={dividendIncome}
        setDividendIncome={setDividendIncome}
        realEstateIncome={realEstateIncome}
        setRealEstateIncome={setRealEstateIncome}
        pensionAssets={pensionAssets}
        setPensionAssets={setPensionAssets}
        stockAssets={stockAssets}
        setStockAssets={setStockAssets}
        bondAssets={bondAssets}
        setBondAssets={setBondAssets}
        childSupport={childSupport}
        setChildSupport={setChildSupport}
        mortgage={mortgage}
        setMortgage={setMortgage}
        otherLoans={otherLoans}
        setOtherLoans={setOtherLoans}
        insurances={insurances}
        setInsurances={setInsurances}
        utilities={utilities}
        setUtilities={setUtilities}
        subscriptionServices={subscriptionServices}
        setSubscriptionServices={setSubscriptionServices}
        incometaxAndPropertyTax={incometaxAndPropertyTax}
        setIncometaxAndPropertyTax={setIncometaxAndPropertyTax} />
      <RowFlexBox style={{ flexDirection: 'row-reverse' }}>
        <button style={{ marginTop: 12, marginBottom: 12, width: '50%' }} onClick={handleNext} className={incomeMissing || assetsMissing || expensesMissing ? "disable" : ""}>
          {lang(TranslatedTerms.NEXT).toUpperCase()}
        </button>
      </RowFlexBox>
    </ColumnFlexBox>
  )
};


export const PublicInvestorTest: React.FC = () => {
  const tablet = IsTablet(useWindowSize().width)

  return (
    <Body>
      <div style={{ width: tablet ? "100%" : TabletMax, margin: 'auto', marginTop: 40 }}>
        <div className="cardnohover padding">
          <img
            width="250px"
            src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png"
            alt="Fundbricks logo" />
          <PublicInvestorTestItem />
        </div>
      </div>
    </Body>
  )
};
